import React, {useEffect, useState} from "react";
import {useDebounce} from "../Lab/useDebounce";
import axios from "axios";
import {config} from "../../Helpers/env";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../actions/snackbarActions";
import {connect} from "react-redux";
import {logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {CustomTablePagination, EnhancedSearchTableToolbar} from "../Utils/Tables/CustomTable";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Container, RightAlignedContainer} from "../Utils/styledComponents";
import {BackButton} from "../Utils/Buttons/DataExportationButton";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import {CustomTableCell, MuiPaper, StickyHeadTable} from "../Utils/Tables/StickyHeaderTable";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {LoadingGif} from "../Utils/Loader";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {AddExchangeRate} from "./AddExchangeRate";
import {formatDate} from "../Utils/ConvertDate";
import {EditExchangeRate} from "./EditExchangeRate";


const headData = [
    {id: 'date_as_of', numeric: false, disablePadding: false, label: 'As of Date'},
    {id: 'exchange_rate', numeric: false, disablePadding: false, label: 'Exchange Rate'},
    {id: 'recorded_by', numeric: false, disablePadding: false, label: 'Recorded By'},
    {id: 'action', numeric: false, disablePadding: false, label: 'Action'},
];

const ExchangeRatesHistory = ({actions, snackbars, match}) => {
    const {currency_id, name, symbol} = match.params
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({rates: [], loading: 'idle', total: 0});
    const [activePage, setActivePage] = useState(1)
    const [debouncedInputValue] = useDebounce(searchValue, 500)
    const [openDialog, setOpenDialog] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState('idle')
    const [openEdit, setOpenEdit] = React.useState(false)
    const [rateDetails, setRateDetails] = React.useState({})

    const {loading, total, rates} = data

    const isResolved = isSubmitted === 'resolved'
    useEffect(() => {
        setData({...data, loading: 'pending'})
        axios.get(`${config.smsUrl}/currency/get_exchange_rates_by_currency`, {
            params: {
                search: debouncedInputValue,
                page: activePage,
                page_size: rowsPerPage,
                currency_id: Number(currency_id)
            }
        }).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = dt.data ? dt.data : []
            const total_count = dt.total_count ? dt.total_count : 0
            const dataArr = arr.map(item => ({
                ...item,
                date_as_of: formatDate(item.date_as_of),
                exchange_rate: Math.pow(item.exchange_rate, -1),
                action: (
                    <button type="button" onClick={() => {
                        setOpenEdit(true)
                        setRateDetails(item)
                    }} className="btn btn-sm small-btn sms-info-btn mr-2 mb-2">Edit</button>
                )
            }))
            setData({...data, loading: 'success', rates: dataArr, total: total_count})
        }).catch((err) => {
            setData({...data, loading: 'error'})
            logoutErrorMessage(err, null, actions);
        })
    }, [debouncedInputValue, activePage, rowsPerPage, isResolved]);

    const handleSearch = (event) => {
        setSearchValue(event.target.value)
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1)
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };


    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending'
    const isSuccess = loading === 'success'
    const isError = loading === 'error'


    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    const search_bar = (
        <EnhancedSearchTableToolbar
            term={searchValue} handler={handleSearch}
        />
    )
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rates.length - page * rowsPerPage);


    return (
        <div data-testid={`exchange-rates`}>
            <PageTitle title='Exchange Rates'/>
            <SubHeader title="Settings" subTitle='Exhange Rates'>
                <FontAwesomeIcon icon={faCog}/>
            </SubHeader>
            <Container>
                <div className="row mb-0">
                    <div className="col-lg-6">
                        <BackButton to='/currencysetup' text='Currencies'/>
                    </div>
                    <div className="col-lg-6">
                        <RightAlignedContainer>
                            <button type="button" onClick={() => setOpenDialog(true)}
                                    className="btn btn-sm small sms-info-btn">Add exchange rate
                            </button>
                        </RightAlignedContainer>
                    </div>
                </div>
                <AddExchangeRate {...{
                    openDialog,
                    setOpenDialog,
                    isSubmitted,
                    setIsSubmitted,
                    actions,
                    currencyDetails: {currency_id, currency_name: name, currency_symbol: symbol}
                }}/>

                <EditExchangeRate {...{
                    openDialog: openEdit,
                    setOpenDialog: setOpenEdit,
                    isSubmitted,
                    setIsSubmitted,
                    actions,
                    currencyDetails: rateDetails
                }}/>
                <MainSnackbar variant={type} open={openBar} message={message}
                              handleCloseBar={closeSnackbar}/>
                <MuiPaper>
                    {search_bar}
                    <StickyHeadTable {...{
                        width: '100%',
                        data: rates,
                        columns: headData.filter(item => Boolean(item)),
                        pagination
                    }}>
                        {isLoading ? <TableRow><TableCell
                            align='center' {...{colSpan: headData.length}}><LoadingGif/></TableCell></TableRow> : null}
                        {isSuccess ? rates.length > 0 ?
                            <>
                                {rates.slice(0, rowsPerPage).map((row, index) => {
                                    const count = ((activePage - 1) * 10) + index + 1;
                                    return (
                                        <TableRow tabIndex={-1} key={index}>
                                            {headData.map(col => (
                                                col.id === 'count' ? <CustomTableCell>{count}</CustomTableCell> :
                                                    <CustomTableCell>{row[col.id]}</CustomTableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{height: 20 * emptyRows}}>
                                        <TableCell colSpan={headData.length}/>
                                    </TableRow>
                                )}
                            </> : <TableRow><TableCell align='center'  {...{colSpan: headData.length}}>No records
                                found</TableCell></TableRow> : null}
                        {isError ?
                            <TableRow><TableCell align='center'  {...{colSpan: headData.length}}>The server did not
                                return a valid response</TableCell></TableRow> : null}
                    </StickyHeadTable>
                </MuiPaper>
            </Container>

        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeRatesHistory);